import { render, staticRenderFns } from "./PieChart.vue?vue&type=template&id=b569d7f4"
import script from "./PieChart.vue?vue&type=script&lang=js"
export * from "./PieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b569d7f4')) {
      api.createRecord('b569d7f4', component.options)
    } else {
      api.reload('b569d7f4', component.options)
    }
    module.hot.accept("./PieChart.vue?vue&type=template&id=b569d7f4", function () {
      api.rerender('b569d7f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/PieChart.vue"
export default component.exports